export const styles = {
  dialogTitle: {
    pt: 2,
    pl: 3,
  },
};
